<template>
  <div class="d-flex flex-row align-items-center">
    <profile-picture
      :width-and-height-in-pixels="60"
      :background-image-url="report?.createdByUser.profilePicture"
    />

    <div class="ms-2">
      <p class="mb-0 text-sm">Gemeld door:</p>
      <h5 class="mb-0">{{ report?.createdByUser.userName }}</h5>
      <p class="mb-0">
        <span>{{ report?.createdByUser.companyName }}</span> /
        <span>{{ report?.createdByUser.profession }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import ProfilePicture from '@/components/UI/ProfilePicture.vue';

export default {
  components: {
    ProfilePicture
  },

  props: {
    report: {
      type: Object,
      required: false,
      default: null
    }
  }
}
</script>

<style scoped>
p {
  font-size: 0.75rem;
}
</style>